/**
 * History Panel — jumpable undo stack for the active page.
 */

import { useCanvasStore } from '@/stores/canvasStore';

export default function HistoryPanel() {
  const { history, historyIndex, jumpToHistory, undo, redo } = useCanvasStore();

  return (
    <div className="ps-history">
      <div className="ps-props-actions" style={{ marginBottom: 8 }}>
        <button
          type="button"
          disabled={historyIndex <= 0}
          onClick={() => undo()}
          title="Undo (Ctrl+Z)"
        >
          Undo
        </button>
        <button
          type="button"
          disabled={historyIndex >= history.length - 1}
          onClick={() => redo()}
          title="Redo (Ctrl+Y)"
        >
          Redo
        </button>
      </div>

      <div className="ps-history-list" role="list">
        {[...history].reverse().map((item, revIdx) => {
          const index = history.length - 1 - revIdx;
          const label = index === 0 ? 'Initial' : `Step ${index}`;
          const active = index === historyIndex;
          return (
            <button
              key={`${item.timestamp}-${index}`}
              type="button"
              role="listitem"
              className={`ps-history-item ${active ? 'active' : ''}`}
              title={new Date(item.timestamp).toLocaleTimeString()}
              onClick={() => jumpToHistory(index)}
            >
              <span>{label}</span>
              <span className="ps-history-time">
                {new Date(item.timestamp).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                })}
              </span>
            </button>
          );
        })}
      </div>

      <p className="ps-props-hint">
        {historyIndex + 1} / {history.length} · click a step to restore
      </p>
    </div>
  );
}
